import { render, staticRenderFns } from "./NewKeywordImport.vue?vue&type=template&id=2afb868c&"
import script from "./NewKeywordImport.vue?vue&type=script&lang=js&"
export * from "./NewKeywordImport.vue?vue&type=script&lang=js&"
import style0 from "./NewKeywordImport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports